import { isClientError } from '@lidea/shared/data-access/core';
import { onlineManager, type MutationOptions } from '@tanstack/react-query';

import { zoningApi } from '../../apis/zoning-api';

type UpdateMeasureVariables = {
  id: number;
  data: { [key: string]: number | string | null };
};

/** One retry max; when offline, still allow one cycle so the retryer can pause instead of error. */
export const measureUpdateRetry: MutationOptions['retry'] = (
  failureCount,
  error
) => {
  if (isClientError(error)) {
    return false;
  }
  return failureCount < 1;
};

export async function updateMeasureMutationFn(props: UpdateMeasureVariables) {
  try {
    return await zoningApi.updateMeasure(props);
  } catch (error) {
    if (!onlineManager.isOnline() || isClientError(error)) {
      throw error;
    }
    // PATCH may have been applied before a client-side failure (response parse, etc.).
    return zoningApi.getMeasure(props.id);
  }
}
